<template>
  <div>
    <el-card class="box_card">
      <div class="title_box">
        <div></div>
        <div>角色信息</div>
      </div>
      <el-form
        ref="form"
        :inline="true"
        :model="form"
        :rules="rules"
        label-width="80px"
        class="demo-form-inline"
      >
        <el-form-item label="角色名称" prop="roleName">
          <el-input
            v-model="form.roleName"
            placeholder="请输入角色名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="form.remark" placeholder="请输入备注"></el-input>
        </el-form-item>
      </el-form>
      <div class="title_box">
        <div></div>
        <div>操作权限</div>
      </div>
      <div class="tree-container">
        <el-tree
          ref="permissionTree"
          :data="menu"
          :props="defaultProps"
          show-checkbox
          node-key="menuId"
          default-expand-all
          :check-strictly="true"
          @check="handleCheckChange"
        >
        </el-tree>
      </div>

      <div class="btn_box">
        <el-button @click="$router.go(-1)">返回</el-button>
        <el-button type="primary" @click="onSubmit">保存</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { roleInfoFromUserId, getRoleInfo, add, edit } from "./service.js";
export default {
  components: {},
  props: {},
  data() {
    return {
      form: {
        roleName: "",
        remark: "",
      },
      rules: {
        roleName: [
          { required: true, message: "请输入角色名称", trigger: "blur" },
        ],
      },
      menu: [],
      defaultProps: {
        children: "children",
        label: "menuName",
      },
    };
  },
  computed: {},
  watch: {},
  created() {
    roleInfoFromUserId().then((res) => {
      // 确保菜单数据正确处理
      this.menu = this.processMenuData(res);

      if (this.$route.query.roleId) {
        getRoleInfo({ id: this.$route.query.roleId }).then((resp) => {
          // 设置表单数据
          const roleData = resp;
          this.form = {
            roleName: roleData.roleName,
            remark: roleData.remark,
            roleId: roleData.roleId,
          };

          // 设置选中的菜单项
          this.$nextTick(() => {
            if (roleData.menus && roleData.menus.length > 0) {
              // 直接使用后端返回的选中节点
              this.$refs.permissionTree.setCheckedKeys(roleData.menus);
            }
          });
        });
      }
    });
  },
  mounted() {},
  methods: {
    // 处理菜单数据，为每个节点添加必要的属性
    processMenuData(menuData) {
      // 如果返回的是嵌套在data.data中的数据
      if (menuData.data && menuData.data.data) {
        menuData = menuData.data.data;
      }

      function traverse(item) {
        // 确保有children属性
        if (!item.children) {
          item.children = [];
        }

        // 递归处理子节点
        if (item.children && item.children.length > 0) {
          item.children.forEach(traverse);
        }
      }

      // 克隆一份数据，避免直接修改原数据
      const clonedData = JSON.parse(JSON.stringify(menuData));
      clonedData.forEach(traverse);

      return clonedData;
    },

    // 复选框状态变化事件处理
    handleCheckChange(data, checked) {
      // 获取树实例
      const tree = this.$refs.permissionTree;

      // 如果是父节点被点击
      if (data.children && data.children.length > 0) {
        // 获取当前节点的选中状态
        const isChecked = tree.getCheckedKeys().includes(data.menuId);

        if (isChecked) {
          // 如果父节点被选中，选中所有子节点
          const childIds = this.getAllChildIds(data);
          const currentCheckedKeys = tree.getCheckedKeys();
          const newCheckedKeys = [
            ...new Set([...currentCheckedKeys, ...childIds]),
          ];
          tree.setCheckedKeys(newCheckedKeys);
        } else {
          // 如果父节点被取消选中，取消选中所有子节点
          const childIds = this.getAllChildIds(data);
          const currentCheckedKeys = tree.getCheckedKeys();
          const newCheckedKeys = currentCheckedKeys.filter(
            (key) => !childIds.includes(key)
          );
          tree.setCheckedKeys(newCheckedKeys);
        }
      } else {
        // 如果是子节点被点击，检查父节点状态
        this.updateParentNodeState(data);
      }
    },

    // 获取节点的所有子节点ID
    getAllChildIds(node) {
      let ids = [];
      if (node.children && node.children.length > 0) {
        node.children.forEach((child) => {
          ids.push(child.menuId);
          ids = ids.concat(this.getAllChildIds(child));
        });
      }
      return ids;
    },

    // 更新父节点状态
    updateParentNodeState(node) {
      const tree = this.$refs.permissionTree;
      const parentNode = this.findParentNode(this.menu, node.menuId);

      if (parentNode) {
        const allChildren = this.getAllChildIds(parentNode);
        const checkedChildren = allChildren.filter((id) =>
          tree.getCheckedKeys().includes(id)
        );

        if (checkedChildren.length === 0) {
          // 如果没有子节点被选中，取消选中父节点
          tree.setChecked(parentNode.menuId, false);
        } else if (checkedChildren.length === allChildren.length) {
          // 如果所有子节点都被选中，选中父节点
          tree.setChecked(parentNode.menuId, true);
        } else {
          // 如果部分子节点被选中，设置父节点为半选状态
          tree.setChecked(parentNode.menuId, false);
          const node = tree.getNode(parentNode.menuId);
          if (node) {
            node.indeterminate = true;
          }
        }

        // 递归更新更上层的父节点
        this.updateParentNodeState(parentNode);
      }
    },

    // 查找节点的父节点
    findParentNode(nodes, targetId, parent = null) {
      for (let node of nodes) {
        if (node.menuId === targetId) {
          return parent;
        }
        if (node.children && node.children.length > 0) {
          const found = this.findParentNode(node.children, targetId, node);
          if (found) return found;
        }
      }
      return null;
    },

    setSelectedIds(arr, selectKeyList) {
      function traverse(item) {
        item.selected = selectKeyList.includes(item.menuId);
        if (item.children && item.children.length > 0) {
          item.children.forEach(traverse);
        }
      }
      arr.forEach(traverse);
      return arr;
    },

    onSubmit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          // 获取选中的节点ID列表
          const checkedKeys = this.$refs.permissionTree.getCheckedKeys();
          const halfCheckedKeys =
            this.$refs.permissionTree.getHalfCheckedKeys();

          // 合并完全选中和半选中的节点
          const allCheckedKeys = [...checkedKeys, ...halfCheckedKeys];

          if (allCheckedKeys.length === 0) {
            this.$message.warning("请勾选操作权限");
            return;
          }

          let obj = {
            ...this.form,
            menuIds: allCheckedKeys,
          };

          if (this.$route.query && this.$route.query.roleId) {
            obj.roleId = this.$route.query.roleId;
            edit(obj).then(() => {
              this.$message.success("保存成功");
              this.$router.go(-1);
            });
          } else {
            add(obj).then(() => {
              this.$message.success("保存成功");
              this.$router.go(-1);
            });
          }
        }
      });
    },

    getSelectedIds(arr) {
      let result = [];
      function traverse(item) {
        if (item.selected) {
          result.push(item.menuId);
        }
        if (item.children && item.children.length > 0) {
          for (let children of item.children) {
            traverse(children);
          }
        }
      }

      for (let item of arr) {
        traverse(item);
      }
      return result;
    },
  },
};
</script>
<style lang="less" scoped>
.box_card {
  margin-bottom: 0;

  .title_box {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-weight: bold;

    div:first-child {
      width: 4px;
      height: 16px;
      background: #598dec;
      margin-right: 8px;
    }
  }

  .btn_box {
    margin-top: 40px;
    text-align: center;
  }
}

.tree-container {
  padding: 20px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  margin: 10px 0;
  background-color: #fff;
  max-height: 600px;
  overflow-y: auto;
}

/* 树节点样式优化 */
::v-deep .el-tree-node__content {
  height: 40px;
  padding: 0 10px;
}

::v-deep .el-tree-node__label {
  font-size: 14px;
}

::v-deep .el-tree-node.is-current > .el-tree-node__content {
  background-color: #f0f7ff;
}

/* 复选框样式优化 */
::v-deep .el-checkbox__inner {
  border-radius: 2px;
}

::v-deep .el-tree-node:hover > .el-tree-node__content {
  background-color: #f5f7fa;
}
</style>